module.exports = __webpack_public_path__ + "assets/amex-4c8a60.svg";